var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOpenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E3132",
    fillRule: "evenodd",
    d: "M10 3.333c2.273 0 4.447 1.193 6.472 3.151.691.669 1.316 1.382 1.867 2.096.332.43.568.77.697.971l.287.45-.287.448c-.13.202-.365.54-.697.972-.55.713-1.176 1.427-1.867 2.095-2.025 1.959-4.199 3.15-6.472 3.15-2.273 0-4.446-1.191-6.472-3.15-.69-.668-1.316-1.382-1.866-2.095-.332-.431-.568-.77-.697-.972L.678 10l.287-.449c.129-.202.365-.54.697-.971.55-.714 1.175-1.427 1.866-2.096 2.026-1.958 4.2-3.15 6.472-3.15zm7.019 6.265c-.504-.654-1.077-1.308-1.705-1.915C13.569 5.995 11.753 5 10 5s-3.569.995-5.313 2.683c-.629.607-1.201 1.261-1.705 1.915-.11.14-.21.275-.302.402.092.127.193.262.302.403.504.653 1.076 1.307 1.705 1.915C6.43 14.005 8.246 15 10 15c1.755 0 3.569-.995 5.313-2.682.629-.608 1.202-1.262 1.706-1.915.109-.141.21-.276.301-.403-.092-.127-.192-.261-.301-.402zM6.667 10c0 1.841 1.492 3.334 3.333 3.334 1.841 0 3.334-1.493 3.334-3.334 0-1.84-1.493-3.333-3.334-3.333-1.84 0-3.333 1.492-3.333 3.333zm5 0c0 .92-.746 1.667-1.667 1.667-.92 0-1.666-.746-1.666-1.667 0-.92.746-1.666 1.666-1.666.92 0 1.667.746 1.667 1.666z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpenIcon);
export default __webpack_public_path__ + "static/media/EyeOpenIcon.829ce669.svg";
export { ForwardRef as ReactComponent };